import type { StickyBottomBarStyles } from "../StickyBottomBar.d";

export const stickyBottomBarMobileStyles: StickyBottomBarStyles = {
  basic: {
    container: {
      bg: "primary.500",
      color: "greyscale.100",
    },
    logo: { display: "none" },
    heading: {
      color: "greyscale.400",
      textTransform: "uppercase",
      letterSpacing: "1.5px",
      fontSize: "xs",
      mb: 1,
    },
    innerContainer: {
      alignItems: "flex-start",
      flexDirection: "column",
      justify: "center",
    },
    actionButton: {
      svg: { boxSize: 4 },
    },
  },
  ahPlus: {
    container: {
      bg: "greyscale.400",
      color: "primary.900",
    },
    innerContainer: {
      w: "full",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    heading: {
      fontSize: "sm",
      flex: 1,
    },
    iconsWithText: { display: "none" },
    logo: {
      w: "23px",
      h: "24px",
    },
    actionButton: {
      svg: { boxSize: 3 },
    },
  },
};
